import { FRAME_PROCESSOR_ERROR_CODES } from '../../../workers/constants/frame-processor-constants';
const KNOWN_ERROR_CODES = new Set<string>(Object.values(FRAME_PROCESSOR_ERROR_CODES));

/**
 * Extracts the error code from a frame processor error message.
 * Error messages follow the format "ERROR_CODE: human message (details)".
 * Returns the code if recognized, 'UNKNOWN' otherwise.
 */
export function extractFrameProcessorErrorCategory(errorMessage: string): string {
  const colonIndex = errorMessage.indexOf(':');
  const candidate = colonIndex > 0 ? errorMessage.substring(0, colonIndex).trim() : '';
  return KNOWN_ERROR_CODES.has(candidate) ? candidate : 'UNKNOWN';
}